import { FC, PropsWithChildren } from 'react';

import { ContentHeader, LayoutWithNavigationBreadcrumbs } from 'components';
import { useTranslation } from 'libs/i18n';
import { RoutesId } from 'libs/navigation';
import { Button, Stack } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';

import {
  DirectoryRecordsTable,
  DirectoryRecordsTableProps,
} from '../components';

import { SearchBarStyled } from './styles';

export interface DirectoryViewProps extends DirectoryRecordsTableProps {
  title: string;
  onClickAdd?: () => void;
  search: string;
  onSearch: (v: string) => void;
}

export const DirectoryView: FC<DirectoryViewProps & PropsWithChildren> = ({
  title,
  onClickAdd,
  children,
  search,
  onSearch,
  ...tableProps
}) => {
  const { t } = useTranslation();
  const noRowsLabel =
    (!!search && t('components.table.searchEmptyData')) || undefined;

  return (
    <LayoutWithNavigationBreadcrumbs titles={{ [RoutesId.directory]: title }}>
      <Stack spacing={24}>
        <ContentHeader
          header={title}
          rightContent={
            <Stack
              alignItems="center"
              direction="row"
              flexWrap="wrap"
              spacing={12}
            >
              <SearchBarStyled search={search} onSearch={onSearch} />
              {onClickAdd ? (
                <Button
                  fullWidth={false}
                  label={t('common.add')}
                  sizeVariant="s"
                  startIcon={<Icon.Plus size={16} />}
                  onClick={onClickAdd}
                />
              ) : null}
            </Stack>
          }
        />

        <DirectoryRecordsTable noRowsLabel={noRowsLabel} {...tableProps} />
      </Stack>
      {children}
    </LayoutWithNavigationBreadcrumbs>
  );
};
